export const colors = {
  orange: '#FEC601',
  purple: '#66095D',
  darkGrey: '#141c21',
  lightDarkGrey: '#3E5967',

  lightGrey: '#edeff2',
  lighterGrey: '#fafcfc',
  yellow: '#FFCD08',
  yellowHover: '#fcd842',
  font: 'rgb(54,49,61);',
  fontLinks: 'rgb(26, 13, 171)',
  black: '#0A0A0A',
  red: '#FE7770',
  darkRed: '#ff5d54',
  lightRed: '#FFD7D5',
  darkBlue: '#081D34',
  lightBlue: '#2E6BE6',
  lightBlueHover: '#c2d6ff'
}

export const smallBoxShadow = 'box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);'
